var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatrix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 577.24 300.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke: url(#Degradado_sin_nombre_64-25);\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68, .cls-69 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68, .cls-69 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-52, .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68, .cls-69 {\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-6, .cls-7, .cls-8, .cls-10, .cls-13, .cls-16, .cls-17, .cls-19, .cls-20, .cls-23, .cls-24, .cls-26, .cls-27, .cls-32, .cls-35, .cls-36, .cls-39, .cls-45, .cls-49, .cls-57, .cls-58, .cls-59, .cls-60, .cls-63, .cls-69 {\r\n        stroke-width: .38px;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke: url(#Degradado_sin_nombre_64-15);\r\n      }\r\n\r\n      .cls-70 {\r\n        fill: url(#Degradado_sin_nombre_35-10);\r\n      }\r\n\r\n      .cls-70, .cls-71, .cls-72, .cls-73, .cls-74, .cls-75, .cls-76, .cls-77, .cls-78, .cls-79, .cls-80, .cls-81, .cls-82, .cls-83, .cls-84, .cls-85 {\r\n        mix-blend-mode: screen;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: url(#Degradado_sin_nombre_64-2);\r\n      }\r\n\r\n      .cls-4 {\r\n        opacity: .8;\r\n        stroke: url(#Degradado_sin_nombre_58-22);\r\n      }\r\n\r\n      .cls-4, .cls-5, .cls-9, .cls-11, .cls-12, .cls-14, .cls-18, .cls-21, .cls-22, .cls-25, .cls-28, .cls-29, .cls-30, .cls-31, .cls-33, .cls-34, .cls-37, .cls-38, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-46, .cls-47, .cls-48, .cls-50, .cls-52, .cls-54, .cls-55, .cls-56, .cls-61, .cls-62, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68 {\r\n        stroke-width: .68px;\r\n      }\r\n\r\n      .cls-71 {\r\n        fill: url(#Degradado_sin_nombre_35-13);\r\n      }\r\n\r\n      .cls-5 {\r\n        opacity: .15;\r\n        stroke: url(#Degradado_sin_nombre_58-35);\r\n      }\r\n\r\n      .cls-72 {\r\n        fill: url(#Degradado_sin_nombre_35-8);\r\n      }\r\n\r\n      .cls-6 {\r\n        stroke: url(#Degradado_sin_nombre_64-8);\r\n      }\r\n\r\n      .cls-86 {\r\n        fill: url(#Degradado_sin_nombre_35-31);\r\n      }\r\n\r\n      .cls-73 {\r\n        fill: url(#Degradado_sin_nombre_35-4);\r\n      }\r\n\r\n      .cls-87 {\r\n        fill: url(#Degradado_sin_nombre_35-19);\r\n      }\r\n\r\n      .cls-88 {\r\n        fill: url(#Degradado_sin_nombre_35-29);\r\n      }\r\n\r\n      .cls-7 {\r\n        stroke: url(#Degradado_sin_nombre_64-16);\r\n      }\r\n\r\n      .cls-8 {\r\n        stroke: url(#Degradado_sin_nombre_64-7);\r\n      }\r\n\r\n      .cls-9 {\r\n        opacity: .7;\r\n        stroke: url(#Degradado_sin_nombre_58-24);\r\n      }\r\n\r\n      .cls-10 {\r\n        stroke: url(#Degradado_sin_nombre_64-20);\r\n      }\r\n\r\n      .cls-74 {\r\n        fill: url(#Degradado_sin_nombre_35-14);\r\n      }\r\n\r\n      .cls-75 {\r\n        fill: url(#Degradado_sin_nombre_35-7);\r\n      }\r\n\r\n      .cls-76 {\r\n        fill: url(#Degradado_sin_nombre_35-5);\r\n      }\r\n\r\n      .cls-11 {\r\n        stroke: url(#Degradado_sin_nombre_58-2);\r\n      }\r\n\r\n      .cls-12 {\r\n        opacity: .3;\r\n        stroke: url(#Degradado_sin_nombre_58-32);\r\n      }\r\n\r\n      .cls-13 {\r\n        stroke: url(#Degradado_sin_nombre_64-3);\r\n      }\r\n\r\n      .cls-77 {\r\n        fill: url(#Degradado_sin_nombre_35-3);\r\n      }\r\n\r\n      .cls-14 {\r\n        opacity: .2;\r\n        stroke: url(#Degradado_sin_nombre_58-34);\r\n      }\r\n\r\n      .cls-15 {\r\n        stroke-width: 1.54px;\r\n      }\r\n\r\n      .cls-15, .cls-51 {\r\n        stroke: #fff;\r\n      }\r\n\r\n      .cls-16 {\r\n        stroke: url(#Degradado_sin_nombre_64-11);\r\n      }\r\n\r\n      .cls-17 {\r\n        stroke: url(#Degradado_sin_nombre_64-13);\r\n      }\r\n\r\n      .cls-89 {\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-18 {\r\n        stroke: url(#Degradado_sin_nombre_58-3);\r\n      }\r\n\r\n      .cls-19 {\r\n        stroke: url(#Degradado_sin_nombre_64-26);\r\n      }\r\n\r\n      .cls-20 {\r\n        stroke: url(#Degradado_sin_nombre_64-23);\r\n      }\r\n\r\n      .cls-21 {\r\n        stroke: url(#Degradado_sin_nombre_58-7);\r\n      }\r\n\r\n      .cls-90 {\r\n        fill: #00a1ff;\r\n        font-family: MyriadPro-Regular, 'Myriad Pro';\r\n        font-size: 10.59px;\r\n      }\r\n\r\n      .cls-22 {\r\n        stroke: url(#Degradado_sin_nombre_58-6);\r\n      }\r\n\r\n      .cls-23 {\r\n        stroke: url(#Degradado_sin_nombre_64-27);\r\n      }\r\n\r\n      .cls-24 {\r\n        stroke: url(#Degradado_sin_nombre_64-12);\r\n      }\r\n\r\n      .cls-25 {\r\n        stroke: url(#Degradado_sin_nombre_58-10);\r\n      }\r\n\r\n      .cls-26 {\r\n        stroke: url(#Degradado_sin_nombre_64-10);\r\n      }\r\n\r\n      .cls-27 {\r\n        stroke: url(#Degradado_sin_nombre_64-18);\r\n      }\r\n\r\n      .cls-28 {\r\n        stroke: url(#Degradado_sin_nombre_58-15);\r\n      }\r\n\r\n      .cls-29 {\r\n        stroke: url(#Degradado_sin_nombre_58-8);\r\n      }\r\n\r\n      .cls-30 {\r\n        stroke: url(#Degradado_sin_nombre_58-17);\r\n      }\r\n\r\n      .cls-91 {\r\n        fill: url(#Degradado_sin_nombre_35-18);\r\n      }\r\n\r\n      .cls-78 {\r\n        fill: url(#Degradado_sin_nombre_35-2);\r\n      }\r\n\r\n      .cls-31 {\r\n        opacity: .45;\r\n        stroke: url(#Degradado_sin_nombre_58-29);\r\n      }\r\n\r\n      .cls-92 {\r\n        fill: url(#Degradado_sin_nombre_35-23);\r\n      }\r\n\r\n      .cls-32 {\r\n        stroke: url(#Degradado_sin_nombre_64-21);\r\n      }\r\n\r\n      .cls-33 {\r\n        stroke: url(#Degradado_sin_nombre_58-5);\r\n      }\r\n\r\n      .cls-93 {\r\n        fill: url(#Degradado_sin_nombre_48);\r\n      }\r\n\r\n      .cls-34 {\r\n        stroke: url(#Degradado_sin_nombre_58);\r\n      }\r\n\r\n      .cls-94 {\r\n        fill: url(#Degradado_sin_nombre_54);\r\n      }\r\n\r\n      .cls-79 {\r\n        fill: url(#Degradado_sin_nombre_35-16);\r\n      }\r\n\r\n      .cls-35 {\r\n        stroke: url(#Degradado_sin_nombre_64-14);\r\n      }\r\n\r\n      .cls-36 {\r\n        stroke: url(#Degradado_sin_nombre_64-6);\r\n      }\r\n\r\n      .cls-95 {\r\n        fill: url(#Degradado_sin_nombre_35-30);\r\n      }\r\n\r\n      .cls-37 {\r\n        opacity: .75;\r\n        stroke: url(#Degradado_sin_nombre_58-23);\r\n      }\r\n\r\n      .cls-38 {\r\n        stroke: url(#Degradado_sin_nombre_58-13);\r\n      }\r\n\r\n      .cls-96 {\r\n        fill: url(#Degradado_sin_nombre_35-32);\r\n      }\r\n\r\n      .cls-39 {\r\n        stroke: url(#Degradado_sin_nombre_64-4);\r\n      }\r\n\r\n      .cls-40 {\r\n        opacity: .6;\r\n        stroke: url(#Degradado_sin_nombre_58-26);\r\n      }\r\n\r\n      .cls-41 {\r\n        opacity: .25;\r\n        stroke: url(#Degradado_sin_nombre_58-33);\r\n      }\r\n\r\n      .cls-80 {\r\n        fill: url(#Degradado_sin_nombre_35-11);\r\n      }\r\n\r\n      .cls-42 {\r\n        stroke: url(#Degradado_sin_nombre_58-11);\r\n      }\r\n\r\n      .cls-97 {\r\n        fill: url(#Degradado_sin_nombre_35-34);\r\n      }\r\n\r\n      .cls-98 {\r\n        fill: url(#Degradado_sin_nombre_35-26);\r\n      }\r\n\r\n      .cls-81 {\r\n        fill: url(#Degradado_sin_nombre_35-9);\r\n      }\r\n\r\n      .cls-43 {\r\n        opacity: .35;\r\n        stroke: url(#Degradado_sin_nombre_58-31);\r\n      }\r\n\r\n      .cls-44 {\r\n        stroke: url(#Degradado_sin_nombre_58-18);\r\n      }\r\n\r\n      .cls-45 {\r\n        stroke: url(#Degradado_sin_nombre_64-9);\r\n      }\r\n\r\n      .cls-46 {\r\n        stroke: url(#Degradado_sin_nombre_40);\r\n      }\r\n\r\n      .cls-47 {\r\n        opacity: .65;\r\n        stroke: url(#Degradado_sin_nombre_58-25);\r\n      }\r\n\r\n      .cls-48 {\r\n        opacity: .05;\r\n        stroke: url(#Degradado_sin_nombre_58-37);\r\n      }\r\n\r\n      .cls-49 {\r\n        stroke: url(#Degradado_sin_nombre_64-22);\r\n      }\r\n\r\n      .cls-50 {\r\n        stroke: url(#Degradado_sin_nombre_58-12);\r\n      }\r\n\r\n      .cls-99 {\r\n        clip-path: url(#clippath);\r\n      }\r\n\r\n      .cls-100 {\r\n        fill: url(#Degradado_sin_nombre_35-20);\r\n      }\r\n\r\n      .cls-101 {\r\n        fill: url(#Degradado_sin_nombre_35-17);\r\n      }\r\n\r\n      .cls-51 {\r\n        stroke-width: .35px;\r\n      }\r\n\r\n      .cls-102 {\r\n        fill: url(#Degradado_sin_nombre_35-24);\r\n      }\r\n\r\n      .cls-52 {\r\n        stroke: url(#Degradado_sin_nombre_58-20);\r\n      }\r\n\r\n      .cls-52, .cls-64 {\r\n        opacity: .95;\r\n      }\r\n\r\n      .cls-54 {\r\n        opacity: .4;\r\n        stroke: url(#Degradado_sin_nombre_58-30);\r\n      }\r\n\r\n      .cls-103 {\r\n        fill: url(#Degradado_sin_nombre_35-28);\r\n      }\r\n\r\n      .cls-82 {\r\n        fill: url(#Degradado_sin_nombre_35-12);\r\n      }\r\n\r\n      .cls-55 {\r\n        stroke: url(#Degradado_sin_nombre_58-16);\r\n      }\r\n\r\n      .cls-56 {\r\n        opacity: .5;\r\n        stroke: url(#Degradado_sin_nombre_58-28);\r\n      }\r\n\r\n      .cls-57 {\r\n        stroke: url(#Degradado_sin_nombre_64);\r\n      }\r\n\r\n      .cls-58 {\r\n        stroke: url(#Degradado_sin_nombre_64-28);\r\n      }\r\n\r\n      .cls-59 {\r\n        stroke: url(#Degradado_sin_nombre_64-19);\r\n      }\r\n\r\n      .cls-60 {\r\n        stroke: url(#Degradado_sin_nombre_64-17);\r\n      }\r\n\r\n      .cls-61 {\r\n        stroke: url(#Degradado_sin_nombre_58-4);\r\n      }\r\n\r\n      .cls-104 {\r\n        fill: url(#Degradado_sin_nombre_35-27);\r\n      }\r\n\r\n      .cls-62 {\r\n        opacity: .55;\r\n        stroke: url(#Degradado_sin_nombre_58-27);\r\n      }\r\n\r\n      .cls-105 {\r\n        filter: url(#luminosity-noclip);\r\n      }\r\n\r\n      .cls-106 {\r\n        mask: url(#mask-1);\r\n      }\r\n\r\n      .cls-107 {\r\n        mask: url(#mask);\r\n      }\r\n\r\n      .cls-83 {\r\n        fill: url(#Degradado_sin_nombre_35-6);\r\n      }\r\n\r\n      .cls-63 {\r\n        stroke: url(#Degradado_sin_nombre_64-24);\r\n      }\r\n\r\n      .cls-108 {\r\n        fill: url(#Degradado_sin_nombre_35-33);\r\n      }\r\n\r\n      .cls-84 {\r\n        fill: url(#Degradado_sin_nombre_35-15);\r\n      }\r\n\r\n      .cls-109 {\r\n        fill: url(#Degradado_sin_nombre_35-21);\r\n      }\r\n\r\n      .cls-64 {\r\n        stroke: url(#Degradado_sin_nombre_58-19);\r\n      }\r\n\r\n      .cls-85 {\r\n        fill: url(#Degradado_sin_nombre_35);\r\n      }\r\n\r\n      .cls-65 {\r\n        opacity: .85;\r\n        stroke: url(#Degradado_sin_nombre_58-21);\r\n      }\r\n\r\n      .cls-110 {\r\n        fill: url(#Degradado_sin_nombre_35-25);\r\n      }\r\n\r\n      .cls-111 {\r\n        filter: url(#luminosity-noclip-2);\r\n      }\r\n\r\n      .cls-66 {\r\n        opacity: .1;\r\n        stroke: url(#Degradado_sin_nombre_58-36);\r\n      }\r\n\r\n      .cls-112 {\r\n        fill: url(#Degradado_sin_nombre_35-22);\r\n      }\r\n\r\n      .cls-67 {\r\n        stroke: url(#Degradado_sin_nombre_58-14);\r\n      }\r\n\r\n      .cls-68 {\r\n        stroke: url(#Degradado_sin_nombre_58-9);\r\n      }\r\n\r\n      .cls-69 {\r\n        stroke: url(#Degradado_sin_nombre_64-5);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 258.47,
    y: 13.58,
    width: 273,
    height: 273,
    rx: 21.31,
    ry: 21.31
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_54",
    "data-name": "Degradado sin nombre 54",
    x1: 197.51,
    y1: 150.83,
    x2: 479.74,
    y2: 150.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00a1ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#00a1ff",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#00a1ff",
    stopOpacity: 0.77
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a1ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_40",
    "data-name": "Degradado sin nombre 40",
    x1: 197.17,
    y1: 150.83,
    x2: 480.08,
    y2: 150.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a1ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#01a1ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#08a4ff",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#14a8ff",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#25aeff",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#3bb6ff",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#56c0ff",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#7cf",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9cdaff",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#c7eaff",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f5fbff",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 0,
    y: 15.68,
    width: 483,
    height: 265.13,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_48",
    "data-name": "Degradado sin nombre 48",
    x1: 133.8,
    y1: 148.24,
    x2: 483,
    y2: 148.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#dadada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 15.68,
    width: 483,
    height: 265.13,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-105"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 133.8,
    y: 15.68,
    width: 349.21,
    height: 265.13
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 64.76,
    y: 16.4,
    width: 420.81,
    height: 259.13,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 64.76,
    y: 16.4,
    width: 420.81,
    height: 259.13,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-111"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m382.54,275.53c9.6-63.31,47.23-61.95,61.13-61.37,13.9.58,23.96-4.2,24.31-12.77.2-4.86-2.51-9.02-2.32-13.71.11-2.64,4.16-2.88,4.33-7,.17-4.12-3.18-6.9-3.18-6.9,0,0,4.55-6.25,4.7-9.79.15-3.54-4.1-5.95-3.99-8.61.19-5.25,9.56-4.53,11.58-9.48,2.02-4.95-1.26-8.43-3.85-11.5-2.6-3.08-9.64-11.57-12.57-16.24-3.27-5.2-3.73-11.54-3.27-22.66,1.72-41.51-42.23-68.09-73.12-69.37h-188.8v-9.73h288.06v259.13h-103.02"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35",
    "data-name": "Degradado sin nombre 35",
    x1: 139.77,
    y1: 268.84,
    x2: 386.32,
    y2: 268.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a1ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00a1ff",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#00a1ff",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a1ff",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-2",
    "data-name": "Degradado sin nombre 35",
    x1: 138.46,
    y1: 270.92,
    x2: 385.02,
    y2: 270.92,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-3",
    "data-name": "Degradado sin nombre 35",
    x1: 74.91,
    y1: 255.56,
    x2: 399.25,
    y2: 255.56,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-4",
    "data-name": "Degradado sin nombre 35",
    x1: 147.96,
    y1: 207.77,
    x2: 472.3,
    y2: 207.77,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-5",
    "data-name": "Degradado sin nombre 35",
    x1: 64.76,
    y1: 227.39,
    x2: 410.64,
    y2: 227.39,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-6",
    "data-name": "Degradado sin nombre 35",
    x1: 129.28,
    y1: 183.86,
    x2: 475.16,
    y2: 183.86,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-7",
    "data-name": "Degradado sin nombre 35",
    x1: 134.92,
    y1: 179.25,
    x2: 480.8,
    y2: 179.25,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-8",
    "data-name": "Degradado sin nombre 35",
    x1: 134.92,
    y1: 159.33,
    x2: 480.8,
    y2: 159.33,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-9",
    "data-name": "Degradado sin nombre 35",
    x1: 118.88,
    y1: 116.91,
    x2: 464.76,
    y2: 116.91,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-10",
    "data-name": "Degradado sin nombre 35",
    x1: 126.42,
    y1: 123.18,
    x2: 472.3,
    y2: 123.18,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-11",
    "data-name": "Degradado sin nombre 35",
    x1: 114.69,
    y1: 73.38,
    x2: 460.57,
    y2: 73.38,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-12",
    "data-name": "Degradado sin nombre 35",
    x1: 118.41,
    y1: 93.35,
    x2: 464.29,
    y2: 93.35,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-13",
    "data-name": "Degradado sin nombre 35",
    x1: 125.07,
    y1: 101.41,
    x2: 470.95,
    y2: 101.41,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-14",
    "data-name": "Degradado sin nombre 35",
    x1: 114.69,
    y1: 45.98,
    x2: 460.57,
    y2: 45.98,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-15",
    "data-name": "Degradado sin nombre 35",
    x1: 134.92,
    y1: 144.94,
    x2: 480.8,
    y2: 144.94,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-16",
    "data-name": "Degradado sin nombre 35",
    x1: 124.24,
    y1: 201.76,
    x2: 458.47,
    y2: 201.76,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58",
    "data-name": "Degradado sin nombre 58",
    x1: 431.11,
    y1: 275.87,
    x2: 431.11,
    y2: 25.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a1ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-2",
    "data-name": "Degradado sin nombre 58",
    x1: 429.47,
    x2: 429.47,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-3",
    "data-name": "Degradado sin nombre 58",
    x1: 427.83,
    x2: 427.83,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-4",
    "data-name": "Degradado sin nombre 58",
    x1: 426.19,
    x2: 426.19,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-5",
    "data-name": "Degradado sin nombre 58",
    x1: 424.55,
    x2: 424.55,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-6",
    "data-name": "Degradado sin nombre 58",
    x1: 422.91,
    x2: 422.91,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-7",
    "data-name": "Degradado sin nombre 58",
    x1: 421.27,
    x2: 421.27,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-8",
    "data-name": "Degradado sin nombre 58",
    x1: 419.63,
    y1: 275.87,
    x2: 419.63,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-9",
    "data-name": "Degradado sin nombre 58",
    x1: 417.98,
    y1: 275.87,
    x2: 417.98,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-10",
    "data-name": "Degradado sin nombre 58",
    x1: 416.34,
    y1: 275.87,
    x2: 416.34,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-11",
    "data-name": "Degradado sin nombre 58",
    x1: 414.7,
    y1: 275.87,
    x2: 414.7,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-12",
    "data-name": "Degradado sin nombre 58",
    x1: 413.06,
    y1: 275.87,
    x2: 413.06,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-13",
    "data-name": "Degradado sin nombre 58",
    x1: 411.42,
    y1: 275.87,
    x2: 411.42,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-14",
    "data-name": "Degradado sin nombre 58",
    x1: 409.78,
    y1: 275.87,
    x2: 409.78,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-15",
    "data-name": "Degradado sin nombre 58",
    x1: 408.14,
    y1: 275.87,
    x2: 408.14,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-16",
    "data-name": "Degradado sin nombre 58",
    x1: 406.5,
    y1: 275.87,
    x2: 406.5,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-17",
    "data-name": "Degradado sin nombre 58",
    x1: 404.86,
    y1: 275.87,
    x2: 404.86,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-18",
    "data-name": "Degradado sin nombre 58",
    x1: 403.22,
    y1: 275.87,
    x2: 403.22,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-19",
    "data-name": "Degradado sin nombre 58",
    x1: 401.57,
    y1: 275.87,
    x2: 401.57,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-20",
    "data-name": "Degradado sin nombre 58",
    x1: 399.93,
    y1: 275.87,
    x2: 399.93,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-21",
    "data-name": "Degradado sin nombre 58",
    x1: 398.29,
    y1: 275.87,
    x2: 398.29,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-22",
    "data-name": "Degradado sin nombre 58",
    x1: 396.65,
    y1: 275.87,
    x2: 396.65,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-23",
    "data-name": "Degradado sin nombre 58",
    x1: 395.01,
    y1: 275.87,
    x2: 395.01,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-24",
    "data-name": "Degradado sin nombre 58",
    x1: 393.37,
    y1: 275.87,
    x2: 393.37,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-25",
    "data-name": "Degradado sin nombre 58",
    x1: 391.73,
    y1: 275.87,
    x2: 391.73,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-26",
    "data-name": "Degradado sin nombre 58",
    x1: 390.09,
    y1: 275.87,
    x2: 390.09,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-27",
    "data-name": "Degradado sin nombre 58",
    x1: 388.45,
    y1: 275.87,
    x2: 388.45,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-28",
    "data-name": "Degradado sin nombre 58",
    x1: 386.8,
    y1: 275.87,
    x2: 386.8,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-29",
    "data-name": "Degradado sin nombre 58",
    x1: 385.16,
    y1: 275.87,
    x2: 385.16,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-30",
    "data-name": "Degradado sin nombre 58",
    x1: 383.52,
    y1: 275.87,
    x2: 383.52,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-31",
    "data-name": "Degradado sin nombre 58",
    x1: 381.88,
    y1: 275.87,
    x2: 381.88,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-32",
    "data-name": "Degradado sin nombre 58",
    x1: 380.24,
    y1: 275.87,
    x2: 380.24,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-33",
    "data-name": "Degradado sin nombre 58",
    x1: 378.6,
    y1: 275.87,
    x2: 378.6,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-34",
    "data-name": "Degradado sin nombre 58",
    x1: 376.96,
    y1: 275.87,
    x2: 376.96,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-35",
    "data-name": "Degradado sin nombre 58",
    x1: 375.32,
    y1: 275.87,
    x2: 375.32,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-36",
    "data-name": "Degradado sin nombre 58",
    x1: 373.68,
    y1: 275.87,
    x2: 373.68,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_58-37",
    "data-name": "Degradado sin nombre 58",
    x1: 372.03,
    y1: 275.87,
    x2: 372.03,
    xlinkHref: "#Degradado_sin_nombre_58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64",
    "data-name": "Degradado sin nombre 64",
    x1: 316.04,
    y1: 165.1,
    x2: 499.83,
    y2: 165.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#fff",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#fff",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#fff",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-2",
    "data-name": "Degradado sin nombre 64",
    x1: 301.27,
    y1: 159.33,
    x2: 485.06,
    y2: 159.33,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-3",
    "data-name": "Degradado sin nombre 64",
    x1: 392.47,
    y1: 43.66,
    x2: 576.26,
    y2: 43.66,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-4",
    "data-name": "Degradado sin nombre 64",
    x1: 296.35,
    y1: 73.38,
    x2: 480.14,
    y2: 73.38,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-5",
    "data-name": "Degradado sin nombre 64",
    x1: 284.86,
    y1: 66.9,
    x2: 468.65,
    y2: 66.9,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-17",
    "data-name": "Degradado sin nombre 35",
    x1: 81.7,
    y1: 206.37,
    x2: 244.42,
    y2: 206.37,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-18",
    "data-name": "Degradado sin nombre 35",
    x1: 47.93,
    y1: 188.47,
    x2: 210.64,
    y2: 188.47,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-19",
    "data-name": "Degradado sin nombre 35",
    x1: 175.91,
    y1: 220.29,
    x2: 338.62,
    y2: 220.29,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-20",
    "data-name": "Degradado sin nombre 35",
    x1: 200.24,
    y1: 219.57,
    x2: 362.96,
    y2: 219.57,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-21",
    "data-name": "Degradado sin nombre 35",
    x1: 212.97,
    y1: 227.14,
    x2: 375.68,
    y2: 227.14,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-22",
    "data-name": "Degradado sin nombre 35",
    x1: 116.4,
    y1: 119.5,
    x2: 459.52,
    y2: 119.5,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-23",
    "data-name": "Degradado sin nombre 35",
    x1: 103.69,
    y1: 121.51,
    x2: 446.81,
    y2: 121.51,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-24",
    "data-name": "Degradado sin nombre 35",
    x1: 116.15,
    y1: 291.68,
    x2: 278.87,
    y2: 291.68,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-25",
    "data-name": "Degradado sin nombre 35",
    x1: 237.08,
    y1: 297.32,
    x2: 399.8,
    y2: 297.32,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-26",
    "data-name": "Degradado sin nombre 35",
    x1: 220.87,
    y1: 276.38,
    x2: 383.58,
    y2: 276.38,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-27",
    "data-name": "Degradado sin nombre 35",
    x1: 212.81,
    y1: 280.2,
    x2: 375.53,
    y2: 280.2,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-28",
    "data-name": "Degradado sin nombre 35",
    x1: 196.97,
    y1: 283.7,
    x2: 359.69,
    y2: 283.7,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-29",
    "data-name": "Degradado sin nombre 35",
    x1: 214.2,
    y1: 27.32,
    x2: 409.78,
    y2: 27.32,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-30",
    "data-name": "Degradado sin nombre 35",
    x1: 159.03,
    y1: 14.65,
    x2: 354.61,
    y2: 14.65,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-31",
    "data-name": "Degradado sin nombre 35",
    x1: 96.83,
    y1: 26.13,
    x2: 375.82,
    y2: 26.13,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-32",
    "data-name": "Degradado sin nombre 35",
    x1: 278.03,
    y1: 32.59,
    x2: 473.61,
    y2: 32.59,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-33",
    "data-name": "Degradado sin nombre 35",
    x1: 271.96,
    y1: 60.78,
    x2: 467.54,
    y2: 60.78,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_35-34",
    "data-name": "Degradado sin nombre 35",
    x1: 227.33,
    y1: 247.9,
    x2: 422.91,
    y2: 247.9,
    xlinkHref: "#Degradado_sin_nombre_35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-6",
    "data-name": "Degradado sin nombre 64",
    x1: 333.78,
    y1: 112.3,
    x2: 517.57,
    y2: 112.3,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-7",
    "data-name": "Degradado sin nombre 64",
    x1: 311.12,
    y1: 121.51,
    x2: 494.91,
    y2: 121.51,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-8",
    "data-name": "Degradado sin nombre 64",
    x1: 347.15,
    y1: 96.81,
    x2: 530.94,
    y2: 96.81,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-9",
    "data-name": "Degradado sin nombre 64",
    x1: 289.25,
    y1: 88.74,
    x2: 473.04,
    y2: 88.74,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-10",
    "data-name": "Degradado sin nombre 64",
    y1: 85.09,
    y2: 85.09,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-11",
    "data-name": "Degradado sin nombre 64",
    x1: 319.32,
    y1: 201.44,
    x2: 503.11,
    y2: 201.44,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-12",
    "data-name": "Degradado sin nombre 64",
    x1: 241.87,
    y1: 227.39,
    x2: 425.66,
    y2: 227.39,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-13",
    "data-name": "Degradado sin nombre 64",
    x1: 288.09,
    y1: 231.33,
    x2: 471.88,
    y2: 231.33,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-14",
    "data-name": "Degradado sin nombre 64",
    x1: 261.55,
    y1: 247.9,
    x2: 445.34,
    y2: 247.9,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-15",
    "data-name": "Degradado sin nombre 64",
    x1: 103.5,
    y1: 206.01,
    x2: 287.29,
    y2: 206.01,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-16",
    "data-name": "Degradado sin nombre 64",
    x1: 118.55,
    y1: 203.16,
    x2: 302.34,
    y2: 203.16,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-17",
    "data-name": "Degradado sin nombre 64",
    x1: 60.42,
    y1: 242.37,
    x2: 244.21,
    y2: 242.37,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-18",
    "data-name": "Degradado sin nombre 64",
    x1: 92.68,
    y1: 248.61,
    x2: 276.47,
    y2: 248.61,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-19",
    "data-name": "Degradado sin nombre 64",
    x1: 351.72,
    y1: 35.64,
    x2: 535.51,
    y2: 35.64,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-20",
    "data-name": "Degradado sin nombre 64",
    x1: 104.87,
    y1: 20.19,
    x2: 288.66,
    y2: 20.19,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-21",
    "data-name": "Degradado sin nombre 64",
    x1: 149.97,
    y1: 11.62,
    x2: 333.76,
    y2: 11.62,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-22",
    "data-name": "Degradado sin nombre 64",
    x1: 230.31,
    y1: 1.12,
    x2: 414.1,
    y2: 1.12,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-23",
    "data-name": "Degradado sin nombre 64",
    x1: 95.75,
    y1: 57.66,
    x2: 279.54,
    y2: 57.66,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-24",
    "data-name": "Degradado sin nombre 64",
    x1: 70.97,
    y1: 187.18,
    x2: 254.76,
    y2: 187.18,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-25",
    "data-name": "Degradado sin nombre 64",
    x1: 47.67,
    y1: 155.62,
    x2: 231.46,
    y2: 155.62,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-26",
    "data-name": "Degradado sin nombre 64",
    x1: 118.55,
    y1: 277.26,
    x2: 302.34,
    y2: 277.26,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-27",
    "data-name": "Degradado sin nombre 64",
    x1: 88.56,
    y1: 272.67,
    x2: 272.35,
    y2: 272.67,
    xlinkHref: "#Degradado_sin_nombre_64"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_64-28",
    "data-name": "Degradado sin nombre 64",
    x1: 212.62,
    y1: 45.98,
    x2: 396.41,
    y2: 45.98,
    xlinkHref: "#Degradado_sin_nombre_64"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-99"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "m382.54,275.53c9.6-63.31,47.23-61.95,61.13-61.37,13.9.58,23.96-4.2,24.31-12.77.2-4.86-2.51-9.02-2.32-13.71.11-2.64,4.16-2.88,4.33-7,.17-4.12-3.18-6.9-3.18-6.9,0,0,4.55-6.25,4.7-9.79.15-3.54-4.1-5.95-3.99-8.61.19-5.25,9.56-4.53,11.58-9.48,2.02-4.95-1.26-8.43-3.85-11.5-2.6-3.08-9.64-11.57-12.57-16.24-3.27-5.2-3.73-11.54-3.27-22.66,1.72-41.51-42.23-68.09-73.12-69.37h-188.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "m382.54,275.53c9.6-63.31,47.23-61.95,61.13-61.37,13.9.58,23.96-4.2,24.31-12.77.2-4.86-2.51-9.02-2.32-13.71.11-2.64,4.16-2.88,4.33-7,.17-4.12-3.18-6.9-3.18-6.9,0,0,4.55-6.25,4.7-9.79.15-3.54-4.1-5.95-3.99-8.61.19-5.25,9.56-4.53,11.58-9.48,2.02-4.95-1.26-8.43-3.85-11.5-2.6-3.08-9.64-11.57-12.57-16.24-3.27-5.2-3.73-11.54-3.27-22.66,1.72-41.51-42.23-68.09-73.12-69.37h-188.8"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(118.59 43.66)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10011010111000010101001010100101111010001010100001111101")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(90.69 33.46)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10011010111000010101001010100101111010001010100001111101")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(86.02 54.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10011010111000010101001010101010000110101101010101111110001111101")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(111.62 65.74)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10011010111000010101001010100101111010000000010101010101111101")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(119.7 76.78)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10011010111000010101001010100101101010101010101010101010101011")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(78.38 87.82)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1001101011100001010100101010010111010100001011110010101110010100010101")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(199.29 98.86)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "100110101110000101010010101101010110100001111101")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(86.05 109.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "100110101110000101010010101001010111000010101010101111101010010001011")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(61.64 120.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10011010111000010101001011010000101010101011110010100100111010101001001101")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(61.35 131.98)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "100110101010110000110101010101110001000101010101010001010101001111000101101")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(71.01 143.02)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "100110101101101011000101010101010001100100110010100010100101100101000010101")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(95.21 154.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "100110101110010010101010101011000101010101010100010101010101100010101")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(105.27 165.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1001110101010101011001010101100100101010110001111001010101010101011")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(50.48 176.14)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10011010111000010101000101101001010100011101010111001010101101011010101100101")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(114.31 187.17)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10011010111000010101001010100101111100010001010100011110101011101")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(54.54 198.21)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1001101011100001010100101010101010101010110101010011010101001010100001111101")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(10.6 209.26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10011010111000010101001010100001110001010101010101110011010110010001010100001111101")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(43.86 220.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1001101011100001010100101011000101011010101111000110101011110010110")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(39.25 231.34)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "100110101110000101010010110101101001000111100101011000010010111101")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(0 242.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "100110101110001000011000010111001101011100101100010101010101000010010011")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(39.33 253.41)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1001101011100001010100101010010101010101111100001101111001101001")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(53.13 264.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1001101011100001001101011010110010111001010101011010101010101")), /*#__PURE__*/React.createElement("text", {
    className: "cls-90",
    transform: "translate(89.29 275.49)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "100110101010101011110001010101010100101011100011010101")), /*#__PURE__*/React.createElement("g", {
    className: "cls-106"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 139.77,
    y: 264.23,
    width: 246.55,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 138.46,
    y: 266.31,
    width: 246.55,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 74.91,
    y: 250.95,
    width: 324.34,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 147.96,
    y: 203.16,
    width: 324.34,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 64.76,
    y: 222.78,
    width: 345.88,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 129.28,
    y: 179.25,
    width: 345.88,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 134.92,
    y: 174.65,
    width: 345.88,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 134.92,
    y: 144.02,
    width: 345.88,
    height: 30.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 118.88,
    y: 112.3,
    width: 345.88,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 126.42,
    y: 118.57,
    width: 345.88,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 114.69,
    y: 68.77,
    width: 345.88,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 118.41,
    y: 88.74,
    width: 345.88,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 125.07,
    y: 96.81,
    width: 345.88,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 114.69,
    y: 41.38,
    width: 345.88,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 134.92,
    y: 140.33,
    width: 345.88,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 124.24,
    y: 197.15,
    width: 334.23,
    height: 9.22
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m382.51,275.53c9.6-63.31,47.23-61.95,61.13-61.37,13.9.58,23.96-4.2,24.31-12.77.2-4.86-2.51-9.02-2.32-13.71.11-2.64,4.16-2.88,4.33-7,.17-4.12-3.18-6.9-3.18-6.9,0,0,4.55-6.25,4.7-9.79.15-3.54-4.1-5.95-3.99-8.61.19-5.25,9.56-4.53,11.58-9.48,2.02-4.95-1.26-8.43-3.85-11.5-2.6-3.08-9.64-11.57-12.57-16.24-3.27-5.2-3.73-11.54-3.27-22.66,1.72-41.51-42.23-68.09-73.12-69.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m382.22,275.53c9.34-61.56,45.92-62.09,59.43-61.53,13.51.56,23.29-4.67,23.64-13,.2-4.72-2.44-9.03-2.26-13.6.11-2.56,4.05-2.96,4.21-6.97.17-4-3.09-6.86-3.09-6.86,0,0,4.42-6.28,4.57-9.73.14-3.44-3.98-5.96-3.87-8.55.18-5.1,9.3-4.7,11.26-9.51,1.96-4.81-1.22-8.44-3.75-11.43-2.52-2.99-9.37-11.64-12.22-16.18-3.18-5.06-3.63-11.67-3.18-22.48,1.67-40.36-41.05-68.33-71.09-69.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m381.93,275.53c9.07-59.8,44.6-62.23,57.73-61.69,13.13.54,22.63-5.13,22.96-13.22.19-4.59-2.37-9.05-2.19-13.48.1-2.49,3.93-3.04,4.09-6.93s-3-6.81-3-6.81c0,0,4.3-6.32,4.44-9.66.14-3.35-3.87-5.98-3.76-8.5.18-4.96,9.03-4.88,10.94-9.55,1.91-4.67-1.19-8.45-3.64-11.36-2.45-2.91-9.1-11.72-11.87-16.12-3.09-4.91-3.52-11.79-3.09-22.3,1.63-39.21-39.88-68.56-69.05-69.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m381.64,275.53c8.8-58.04,43.29-62.37,56.03-61.84,12.74.53,21.96-5.6,22.29-13.45.18-4.45-2.3-9.06-2.13-13.37.1-2.42,3.82-3.13,3.97-6.9.16-3.78-2.91-6.77-2.91-6.77,0,0,4.17-6.35,4.31-9.6.13-3.25-3.75-6-3.65-8.44.17-4.81,8.77-5.05,10.62-9.59,1.85-4.54-1.15-8.46-3.53-11.28-2.38-2.82-8.83-11.79-11.52-16.07-3-4.77-3.42-11.92-3-22.11,1.58-38.05-38.71-68.8-67.02-69.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m381.35,275.53c8.54-56.28,41.98-62.51,54.34-62,12.36.51,21.3-6.06,21.61-13.68.18-4.32-2.23-9.08-2.06-13.25.1-2.34,3.7-3.21,3.85-6.87.15-3.66-2.83-6.73-2.83-6.73,0,0,4.04-6.39,4.17-9.54.13-3.15-3.64-6.02-3.54-8.39.17-4.66,8.5-5.22,10.3-9.62,1.8-4.4-1.12-8.47-3.43-11.21-2.31-2.74-8.56-11.86-11.17-16.01-2.91-4.63-3.32-12.05-2.91-21.93,1.53-36.9-37.54-69.03-64.99-70.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m381.06,275.53c8.27-54.52,40.67-62.65,52.64-62.16,11.97.5,20.63-6.53,20.94-13.9.17-4.18-2.16-9.1-2-13.14.09-2.27,3.58-3.29,3.73-6.84.15-3.55-2.74-6.68-2.74-6.68,0,0,3.92-6.43,4.04-9.48.13-3.05-3.53-6.04-3.43-8.33.16-4.52,8.23-5.4,9.97-9.66,1.74-4.26-1.08-8.49-3.32-11.14-2.23-2.65-8.3-11.93-10.82-15.95-2.82-4.48-3.21-12.17-2.81-21.75,1.48-35.75-36.36-69.27-62.96-70.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m380.77,275.53c8-52.76,39.36-62.79,50.94-62.31,11.58.48,19.96-6.99,20.26-14.13.17-4.05-2.1-9.11-1.93-13.03.09-2.2,3.47-3.37,3.61-6.81.14-3.43-2.65-6.64-2.65-6.64,0,0,3.79-6.46,3.91-9.41.12-2.95-3.41-6.06-3.32-8.28.16-4.37,7.97-5.57,9.65-9.69,1.68-4.12-1.05-8.5-3.21-11.06-2.16-2.57-8.03-12-10.47-15.9-2.73-4.34-3.11-12.3-2.72-21.56,1.43-34.59-35.19-69.5-60.93-70.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m380.48,275.53c7.74-51,38.05-62.93,49.24-62.47,11.2.46,19.3-7.46,19.59-14.36.16-3.91-2.03-9.13-1.87-12.91.09-2.12,3.35-3.46,3.49-6.77.14-3.32-2.56-6.6-2.56-6.6,0,0,3.66-6.5,3.78-9.35.12-2.85-3.3-6.08-3.21-8.23.15-4.23,7.7-5.74,9.33-9.73,1.63-3.99-1.01-8.51-3.11-10.99-2.09-2.48-7.76-12.08-10.13-15.84-2.63-4.19-3-12.42-2.63-21.38,1.39-33.44-34.02-69.74-58.9-70.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "m380.19,275.53c7.47-49.24,36.73-63.07,47.54-62.63,10.81.45,18.63-7.92,18.91-14.58.16-3.78-1.96-9.15-1.8-12.8.09-2.05,3.24-3.54,3.37-6.74.13-3.2-2.47-6.56-2.47-6.56,0,0,3.54-6.53,3.65-9.29.11-2.75-3.19-6.1-3.1-8.17.15-4.08,7.44-5.92,9.01-9.77,1.57-3.85-.98-8.52-3-10.92-2.02-2.39-7.49-12.15-9.78-15.78-2.54-4.05-2.9-12.55-2.54-21.2,1.34-32.29-32.84-69.98-56.87-70.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m379.89,275.53c7.2-47.49,35.42-63.22,45.85-62.78,10.42.43,17.97-8.39,18.23-14.81.15-3.64-1.89-9.16-1.74-12.68.08-1.98,3.12-3.62,3.25-6.71.13-3.09-2.38-6.51-2.38-6.51,0,0,3.41-6.57,3.52-9.22.11-2.66-3.07-6.12-2.99-8.12.14-3.94,7.17-6.09,8.69-9.8,1.52-3.71-.94-8.53-2.89-10.84-1.95-2.31-7.23-12.22-9.43-15.72-2.45-3.9-2.8-12.68-2.45-21.02,1.29-31.14-31.67-70.21-54.84-71.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m379.6,275.53c6.94-45.73,34.11-63.36,44.15-62.94,10.04.42,17.3-8.85,17.56-15.04.15-3.51-1.82-9.18-1.68-12.57.08-1.9,3.01-3.7,3.13-6.68.12-2.97-2.3-6.47-2.3-6.47,0,0,3.29-6.6,3.39-9.16.11-2.56-2.96-6.14-2.88-8.06.13-3.79,6.91-6.26,8.37-9.84,1.46-3.57-.91-8.55-2.78-10.77-1.87-2.22-6.96-12.29-9.08-15.67-2.36-3.76-2.69-12.8-2.36-20.83,1.24-29.98-30.5-70.45-52.81-71.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m379.31,275.53c6.67-43.97,32.8-63.5,42.45-63.1,9.65.4,16.64-9.32,16.88-15.26.14-3.37-1.75-9.19-1.61-12.46.08-1.83,2.89-3.78,3.01-6.64.12-2.86-2.21-6.43-2.21-6.43,0,0,3.16-6.64,3.26-9.1.1-2.46-2.84-6.16-2.77-8.01.13-3.64,6.64-6.44,8.04-9.87,1.4-3.44-.87-8.56-2.68-10.7-1.8-2.14-6.69-12.37-8.73-15.61-2.27-3.61-2.59-12.93-2.27-20.65,1.2-28.83-29.32-70.68-50.78-71.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m379.02,275.53c6.4-42.21,31.49-63.64,40.75-63.25,9.27.38,15.97-9.78,16.21-15.49.13-3.24-1.68-9.21-1.55-12.34.07-1.76,2.77-3.87,2.89-6.61.11-2.75-2.12-6.39-2.12-6.39,0,0,3.03-6.68,3.13-9.04.1-2.36-2.73-6.18-2.66-7.95.12-3.5,6.38-6.61,7.72-9.91,1.35-3.3-.84-8.57-2.57-10.62-1.73-2.05-6.42-12.44-8.38-15.55-2.18-3.47-2.49-13.05-2.18-20.47,1.15-27.68-28.15-70.92-48.74-71.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "m378.73,275.53c6.14-40.45,30.17-63.78,39.05-63.41,8.88.37,15.31-10.25,15.53-15.72.13-3.1-1.61-9.23-1.48-12.23.07-1.68,2.66-3.95,2.77-6.58s-2.03-6.34-2.03-6.34c0,0,2.91-6.71,3-8.97.09-2.26-2.62-6.2-2.55-7.9.12-3.35,6.11-6.78,7.4-9.94,1.29-3.16-.8-8.58-2.46-10.55-1.66-1.97-6.16-12.51-8.03-15.5-2.09-3.32-2.38-13.18-2.09-20.28,1.1-26.52-26.98-71.16-46.71-71.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m378.44,275.53c5.87-38.69,28.86-63.92,37.36-63.57,8.49.35,14.64-10.71,14.86-15.94.12-2.97-1.54-9.24-1.42-12.11.07-1.61,2.54-4.03,2.65-6.55.1-2.52-1.94-6.3-1.94-6.3,0,0,2.78-6.75,2.87-8.91.09-2.16-2.5-6.22-2.44-7.84.11-3.21,5.84-6.96,7.08-9.98,1.23-3.02-.77-8.59-2.36-10.47-1.59-1.88-5.89-12.58-7.68-15.44-2-3.18-2.28-13.31-2-20.1,1.05-25.37-25.81-71.39-44.68-72.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "m378.15,275.53c5.6-36.93,27.55-64.06,35.66-63.72,8.11.34,13.98-11.17,14.18-16.17.12-2.83-1.47-9.26-1.35-12,.06-1.54,2.43-4.11,2.53-6.52.1-2.4-1.85-6.26-1.85-6.26,0,0,2.65-6.78,2.74-8.85.09-2.07-2.39-6.24-2.32-7.79.11-3.06,5.58-7.13,6.76-10.02,1.18-2.89-.73-8.61-2.25-10.4-1.51-1.8-5.62-12.66-7.33-15.38-1.91-3.04-2.18-13.43-1.91-19.92,1-24.22-24.63-71.63-42.65-72.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m377.86,275.53c5.34-35.17,26.24-64.2,33.96-63.88,7.72.32,13.31-11.64,13.51-16.4.11-2.7-1.4-9.28-1.29-11.88.06-1.46,2.31-4.2,2.41-6.48.09-2.29-1.77-6.22-1.77-6.22,0,0,2.53-6.82,2.61-8.79.08-1.97-2.28-6.26-2.21-7.73.1-2.92,5.31-7.3,6.44-10.05,1.12-2.75-.7-8.62-2.14-10.33-1.44-1.71-5.35-12.73-6.98-15.32-1.82-2.89-2.07-13.56-1.82-19.74.96-23.06-23.46-71.86-40.62-72.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "m377.57,275.53c5.07-33.42,24.93-64.34,32.26-64.04,7.34.3,12.64-12.1,12.83-16.62.11-2.57-1.33-9.29-1.22-11.77.06-1.39,2.2-4.28,2.29-6.45.09-2.17-1.68-6.17-1.68-6.17,0,0,2.4-6.85,2.48-8.72.08-1.87-2.16-6.27-2.1-7.68.1-2.77,5.05-7.48,6.11-10.09,1.07-2.61-.66-8.63-2.03-10.25-1.37-1.62-5.09-12.8-6.63-15.27-1.73-2.75-1.97-13.68-1.73-19.55.91-21.91-22.29-72.1-38.59-72.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m377.27,275.53c4.8-31.66,23.61-64.48,30.56-64.2,6.95.29,11.98-12.57,12.16-16.85.1-2.43-1.26-9.31-1.16-11.66.05-1.32,2.08-4.36,2.17-6.42.09-2.06-1.59-6.13-1.59-6.13,0,0,2.27-6.89,2.35-8.66.07-1.77-2.05-6.29-1.99-7.63.09-2.62,4.78-7.65,5.79-10.12,1.01-2.47-.63-8.64-1.93-10.18-1.3-1.54-4.82-12.88-6.28-15.21-1.64-2.6-1.86-13.81-1.63-19.37.86-20.76-21.11-72.33-36.56-72.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m376.98,275.53c4.54-29.9,22.3-64.62,28.87-64.35,6.56.27,11.31-13.03,11.48-17.08.1-2.29-1.19-9.33-1.1-11.54.05-1.24,1.97-4.44,2.05-6.39.08-1.95-1.5-6.09-1.5-6.09,0,0,2.15-6.93,2.22-8.6s-1.93-6.31-1.88-7.57c.09-2.48,4.52-7.82,5.47-10.16.95-2.34-.59-8.65-1.82-10.11-1.23-1.45-4.55-12.95-5.94-15.15-1.54-2.46-1.76-13.94-1.54-19.19.81-19.6-19.94-72.57-34.53-73.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m376.69,275.53c4.27-28.14,20.99-64.77,27.17-64.51,6.18.26,10.65-13.5,10.81-17.31.09-2.16-1.12-9.34-1.03-11.43.05-1.17,1.85-4.52,1.93-6.36.08-1.83-1.41-6.05-1.41-6.05,0,0,2.02-6.96,2.09-8.54s-1.82-6.33-1.77-7.52c.08-2.33,4.25-8,5.15-10.2.9-2.2-.56-8.66-1.71-10.03-1.15-1.37-4.28-13.02-5.59-15.1-1.45-2.31-1.66-14.06-1.45-19,.77-18.45-18.77-72.81-32.5-73.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m376.4,275.53c4-26.38,19.68-64.91,25.47-64.67,5.79.24,9.98-13.96,10.13-17.53.08-2.02-1.05-9.36-.97-11.31.05-1.1,1.73-4.61,1.81-6.32.07-1.72-1.32-6-1.32-6,0,0,1.9-7,1.96-8.47.06-1.48-1.71-6.35-1.66-7.46.08-2.19,3.98-8.17,4.83-10.23.84-2.06-.52-8.68-1.61-9.96-1.08-1.28-4.01-13.09-5.24-15.04-1.36-2.17-1.55-14.19-1.36-18.82.72-17.3-17.59-73.04-30.47-73.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "m376.11,275.53c3.74-24.62,18.37-65.05,23.77-64.82,5.41.22,9.32-14.43,9.45-17.76.08-1.89-.98-9.37-.9-11.2.04-1.03,1.62-4.69,1.69-6.29.07-1.6-1.24-5.96-1.24-5.96,0,0,1.77-7.03,1.83-8.41.06-1.38-1.59-6.37-1.55-7.41.07-2.04,3.72-8.34,4.5-10.27.79-1.92-.49-8.69-1.5-9.89-1.01-1.2-3.75-13.17-4.89-14.98-1.27-2.02-1.45-14.31-1.27-18.64.67-16.14-16.42-73.28-28.43-73.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m375.82,275.53c3.47-22.86,17.05-65.19,22.07-64.98,5.02.21,8.65-14.89,8.78-17.99.07-1.75-.91-9.39-.84-11.09.04-.95,1.5-4.77,1.56-6.26.06-1.49-1.15-5.92-1.15-5.92,0,0,1.64-7.07,1.7-8.35.05-1.28-1.48-6.39-1.44-7.35.07-1.89,3.45-8.52,4.18-10.3.73-1.79-.45-8.7-1.39-9.81-.94-1.11-3.48-13.24-4.54-14.92-1.18-1.88-1.35-14.44-1.18-18.46.62-14.99-15.25-73.51-26.4-73.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m375.53,275.53c3.2-21.1,15.74-65.33,20.38-65.14,4.63.19,7.99-15.36,8.1-18.21.07-1.62-.84-9.41-.77-10.97.04-.88,1.39-4.85,1.44-6.23.06-1.37-1.06-5.88-1.06-5.88,0,0,1.52-7.1,1.57-8.28.05-1.18-1.36-6.41-1.33-7.3.06-1.75,3.19-8.69,3.86-10.34.67-1.65-.42-8.71-1.28-9.74-.87-1.03-3.21-13.31-4.19-14.87-1.09-1.73-1.24-14.57-1.09-18.27.57-13.84-14.08-73.75-24.37-74.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m375.24,275.53c2.93-19.35,14.43-65.47,18.68-65.29,4.25.18,7.32-15.82,7.43-18.44.06-1.48-.77-9.42-.71-10.86.03-.81,1.27-4.94,1.32-6.19.05-1.26-.97-5.83-.97-5.83,0,0,1.39-7.14,1.43-8.22.05-1.08-1.25-6.43-1.22-7.24.06-1.6,2.92-8.86,3.54-10.37.62-1.51-.38-8.72-1.18-9.66-.79-.94-2.94-13.38-3.84-14.81-1-1.59-1.14-14.69-1-18.09.53-12.68-12.9-73.99-22.34-74.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m374.95,275.53c2.67-17.59,13.12-65.61,16.98-65.45,3.86.16,6.66-16.29,6.75-18.67.06-1.35-.7-9.44-.64-10.74.03-.73,1.16-5.02,1.2-6.16.05-1.14-.88-5.79-.88-5.79,0,0,1.26-7.18,1.3-8.16.04-.98-1.14-6.45-1.11-7.19.05-1.46,2.66-9.04,3.22-10.41.56-1.37-.35-8.74-1.07-9.59-.72-.86-2.68-13.46-3.49-14.75-.91-1.45-1.04-14.82-.91-17.91.48-11.53-11.73-74.22-20.31-74.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m374.65,275.53c2.4-15.83,11.81-65.75,15.28-65.61,3.47.14,5.99-16.75,6.08-18.89.05-1.21-.63-9.46-.58-10.63.03-.66,1.04-5.1,1.08-6.13.04-1.03-.79-5.75-.79-5.75,0,0,1.14-7.21,1.17-8.1.04-.89-1.02-6.47-1-7.13.05-1.31,2.39-9.21,2.9-10.45.51-1.24-.31-8.75-.96-9.52-.65-.77-2.41-13.53-3.14-14.69-.82-1.3-.93-14.94-.82-17.72.43-10.38-10.56-74.46-18.28-74.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m374.36,275.53c2.13-14.07,10.5-65.89,13.58-65.76,3.09.13,5.32-17.21,5.4-19.12.04-1.08-.56-9.47-.52-10.52.02-.59.93-5.18.96-6.1.04-.92-.71-5.71-.71-5.71,0,0,1.01-7.25,1.04-8.03.03-.79-.91-6.49-.89-7.08.04-1.17,2.13-9.38,2.57-10.48.45-1.1-.28-8.76-.86-9.44-.58-.68-2.14-13.6-2.79-14.64-.73-1.16-.83-15.07-.73-17.54.38-9.23-9.38-74.69-16.25-74.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "m374.07,275.53c1.87-12.31,9.18-66.03,11.89-65.92,2.7.11,4.66-17.68,4.73-19.35.04-.94-.49-9.49-.45-10.4.02-.51.81-5.26.84-6.07.03-.8-.62-5.66-.62-5.66,0,0,.88-7.28.91-7.97.03-.69-.8-6.51-.78-7.02.04-1.02,1.86-9.56,2.25-10.52.39-.96-.24-8.77-.75-9.37-.5-.6-1.87-13.67-2.44-14.58-.64-1.01-.73-15.2-.64-17.36.33-8.07-8.21-74.93-14.22-75.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "m373.78,275.53c1.6-10.55,7.87-66.17,10.19-66.08s3.99-18.14,4.05-19.57c.03-.81-.42-9.5-.39-10.29.02-.44.69-5.35.72-6.03.03-.69-.53-5.62-.53-5.62,0,0,.76-7.32.78-7.91.02-.59-.68-6.53-.66-6.97.03-.87,1.59-9.73,1.93-10.55.34-.83-.21-8.78-.64-9.3-.43-.51-1.61-13.74-2.09-14.52-.55-.87-.62-15.32-.54-17.18.29-6.92-7.04-75.17-12.19-75.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m373.49,275.53c1.33-8.79,6.56-66.31,8.49-66.23,1.93.08,3.33-18.61,3.38-19.8.03-.67-.35-9.52-.32-10.17.02-.37.58-5.43.6-6,.02-.57-.44-5.58-.44-5.58,0,0,.63-7.35.65-7.85.02-.49-.57-6.55-.55-6.92.03-.73,1.33-9.9,1.61-10.59.28-.69-.18-8.8-.54-9.22-.36-.43-1.34-13.82-1.75-14.47-.45-.72-.52-15.45-.45-16.99.24-5.77-5.86-75.4-10.16-75.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m373.2,275.53c1.07-7.03,5.25-66.46,6.79-66.39,1.54.06,2.66-19.07,2.7-20.03.02-.54-.28-9.54-.26-10.06.01-.29.46-5.51.48-5.97.02-.46-.35-5.54-.35-5.54,0,0,.51-7.39.52-7.78.02-.39-.46-6.57-.44-6.86.02-.58,1.06-10.08,1.29-10.63.22-.55-.14-8.81-.43-9.15-.29-.34-1.07-13.89-1.4-14.41-.36-.58-.41-15.57-.36-16.81.19-4.61-4.69-75.64-8.12-75.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m372.91,275.53c.8-5.28,3.94-66.6,5.09-66.55,1.16.05,2-19.54,2.03-20.25.02-.4-.21-9.55-.19-9.94,0-.22.35-5.59.36-5.94.01-.34-.26-5.49-.26-5.49,0,0,.38-7.43.39-7.72.01-.3-.34-6.59-.33-6.81.02-.44.8-10.25.97-10.66.17-.41-.1-8.82-.32-9.08-.22-.26-.8-13.96-1.05-14.35-.27-.43-.31-15.7-.27-16.63.14-3.46-3.52-75.87-6.09-75.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m372.62,275.53c.53-3.52,2.62-66.74,3.4-66.71.77.03,1.33-20,1.35-20.48.01-.27-.14-9.57-.13-9.83,0-.15.23-5.68.24-5.9,0-.23-.18-5.45-.18-5.45,0,0,.25-7.46.26-7.66,0-.2-.23-6.6-.22-6.75.01-.29.53-10.42.64-10.7.11-.27-.07-8.83-.21-9-.14-.17-.54-14.04-.7-14.29-.18-.29-.21-15.83-.18-16.44.1-2.31-2.35-76.11-4.06-76.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "m372.33,275.53c.27-1.76,1.31-66.88,1.7-66.86.39.02.67-20.47.68-20.71,0-.14-.07-9.59-.06-9.72,0-.07.12-5.76.12-5.87,0-.11-.09-5.41-.09-5.41,0,0,.13-7.5.13-7.6,0-.1-.11-6.62-.11-6.7,0-.15.27-10.6.32-10.73.06-.14-.03-8.84-.11-8.93-.07-.09-.27-14.11-.35-14.24-.09-.14-.1-15.95-.09-16.26.05-1.15-1.17-76.34-2.03-76.38"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-48",
    x1: 372.03,
    y1: 275.53,
    x2: 372.03,
    y2: 26.13
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m382.54,275.53c9.6-63.31,47.23-61.95,61.13-61.37,13.9.58,23.96-4.2,24.31-12.77.2-4.86-2.51-9.02-2.32-13.71.11-2.64,4.16-2.88,4.33-7,.17-4.12-3.18-6.9-3.18-6.9,0,0,4.55-6.25,4.7-9.79.15-3.54-4.1-5.95-3.99-8.61.19-5.25,9.56-4.53,11.58-9.48,2.02-4.95-1.26-8.43-3.85-11.5-2.6-3.08-9.64-11.57-12.57-16.24-3.27-5.2-3.73-11.54-3.27-22.66,1.72-41.51-42.23-68.09-73.12-69.37"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-57",
    x1: 499.64,
    y1: 165.1,
    x2: 316.23,
    y2: 165.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m500.04,165.1c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 484.87,
    y1: 159.33,
    x2: 301.46,
    y2: 159.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m485.27,159.33c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 576.07,
    y1: 43.66,
    x2: 392.66,
    y2: 43.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m576.47,43.66c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-39",
    x1: 479.95,
    y1: 73.38,
    x2: 296.54,
    y2: 73.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m480.35,73.38c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 468.46,
    y1: 66.9,
    x2: 285.05,
    y2: 66.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m468.86,66.9c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 81.7,
    y: 203.16,
    width: 162.72,
    height: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 47.93,
    y: 183.86,
    width: 162.72,
    height: 9.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 175.91,
    y: 209.25,
    width: 162.72,
    height: 22.08
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 200.24,
    y: 215.39,
    width: 162.72,
    height: 8.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 212.97,
    y: 221.27,
    width: 162.72,
    height: 11.73
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 116.4,
    y: 113.64,
    width: 343.12,
    height: 11.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 103.69,
    y: 115.65,
    width: 343.12,
    height: 11.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 116.15,
    y: 285.81,
    width: 162.72,
    height: 11.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 237.08,
    y: 294.39,
    width: 162.72,
    height: 5.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 220.87,
    y: 275.49,
    width: 162.72,
    height: 1.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 212.81,
    y: 279.31,
    width: 162.72,
    height: 1.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 196.97,
    y: 280.02,
    width: 162.72,
    height: 7.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 214.2,
    y: 17.4,
    width: 195.58,
    height: 19.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 159.03,
    y: 11.62,
    width: 195.58,
    height: 6.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 96.83,
    y: 20.19,
    width: 278.99,
    height: 11.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 278.03,
    y: 29.53,
    width: 195.58,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 271.96,
    y: 59.22,
    width: 195.58,
    height: 3.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 227.33,
    y: 244.85,
    width: 195.58,
    height: 6.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 517.38,
    y1: 112.3,
    x2: 333.97,
    y2: 112.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m517.78,112.3c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 494.72,
    y1: 121.51,
    x2: 311.31,
    y2: 121.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m495.12,121.51c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 530.75,
    y1: 96.81,
    x2: 347.34,
    y2: 96.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m531.15,96.81c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-45",
    x1: 472.85,
    y1: 88.74,
    x2: 289.45,
    y2: 88.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m473.25,88.74c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 499.64,
    y1: 85.09,
    x2: 316.23,
    y2: 85.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m500.04,85.09c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 502.92,
    y1: 201.44,
    x2: 319.52,
    y2: 201.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m503.33,201.44c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 425.47,
    y1: 227.39,
    x2: 242.06,
    y2: 227.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m425.87,227.39c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 471.69,
    y1: 231.33,
    x2: 288.28,
    y2: 231.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m472.09,231.33c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 445.15,
    y1: 247.9,
    x2: 261.74,
    y2: 247.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m445.55,247.9c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 287.1,
    y1: 206.01,
    x2: 103.69,
    y2: 206.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m287.5,206.01c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 302.14,
    y1: 203.16,
    x2: 118.74,
    y2: 203.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m302.55,203.16c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-60",
    x1: 244.02,
    y1: 242.37,
    x2: 60.61,
    y2: 242.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m244.42,242.37c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 276.28,
    y1: 248.61,
    x2: 92.87,
    y2: 248.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m276.68,248.61c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-59",
    x1: 535.32,
    y1: 35.64,
    x2: 351.92,
    y2: 35.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m535.72,35.64c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 288.47,
    y1: 20.19,
    x2: 105.06,
    y2: 20.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m288.87,20.19c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-32",
    x1: 333.57,
    y1: 11.62,
    x2: 150.16,
    y2: 11.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m333.97,11.62c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-49",
    x1: 413.91,
    y1: 1.12,
    x2: 230.5,
    y2: 1.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m414.31,1.12c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 279.35,
    y1: 57.66,
    x2: 95.95,
    y2: 57.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 279.4,
    cy: 57.66,
    r: 0.35
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-63",
    x1: 254.57,
    y1: 187.18,
    x2: 71.16,
    y2: 187.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m254.97,187.18c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 231.27,
    y1: 155.62,
    x2: 47.87,
    y2: 155.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m231.67,155.62c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 302.14,
    y1: 277.26,
    x2: 118.74,
    y2: 277.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m302.55,277.26c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 272.16,
    y1: 272.67,
    x2: 88.75,
    y2: 272.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m272.56,272.67c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-58",
    x1: 396.22,
    y1: 45.98,
    x2: 212.81,
    y2: 45.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m396.62,45.98c0,.2-.16.35-.35.35s-.35-.16-.35-.35.16-.35.35-.35.35.16.35.35Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatrix);
export default __webpack_public_path__ + "static/media/matrix.3a9e81006b64b30e5b9338745e1407ca.svg";
export { ForwardRef as ReactComponent };